import { createFileRoute } from "@tanstack/react-router";

import { SectionsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/sections")({
  component: SectionsPage,
});
